import { useCallback } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import { useDispatch } from 'react-redux';

import { WalkingTransitionIconSet } from 'components/atoms/CustomSVGIcon';
import { prefillFormAndSearch } from 'features/views/semaphore/actions';
import { useClickTableDataLayer } from 'features/views/semaphore/hooks';
import { generateClickTableValuePair } from 'features/views/semaphore/utils';

export const ImpendingStateTableRow = ({ fromColor, toColor, handleClickData, data, sumValue, tooltip }) => {
	const dispatch = useDispatch();
	const pushToClickTableDataLayer = useClickTableDataLayer();

	const handleClick = useCallback(
		(data) => () => {
			const clickedTableSection = generateClickTableValuePair(data);
			pushToClickTableDataLayer({ value: clickedTableSection })();
			dispatch(prefillFormAndSearch('impendingState', data));
		},
		[dispatch, pushToClickTableDataLayer],
	);

	return (
		<TableRow>
			<TableCell align="center" sx={{ borderBottom: 'unset' }}>
				<Tooltip title={tooltip} sx={{ fontSize: '30px' }}>
					<IconButton disableRipple>
						<WalkingTransitionIconSet fromColor={fromColor} toColor={toColor} />
					</IconButton>
				</Tooltip>
			</TableCell>
			{data &&
				data.map((count, i) => (
					<TableCell align="center" sx={{ fontWeight: 'bold' }} key={i}>
						<Link
							underline="none"
							sx={{ cursor: 'pointer', color: toColor }}
							onClick={handleClick(handleClickData[i])}
						>
							{count}
						</Link>
					</TableCell>
				))}
			<TableCell align="center" sx={{ fontWeight: 'bold', color: toColor }}>
				{sumValue}
			</TableCell>
		</TableRow>
	);
};

ImpendingStateTableRow.propTypes = {
	data: PropTypes.array,
	fromColor: PropTypes.string,
	handleClickData: PropTypes.array,
	name: PropTypes.string,
	sumValue: PropTypes.number,
	toColor: PropTypes.string,
	tooltip: PropTypes.string,
};

export default ImpendingStateTableRow;
